import MuDrawer, { DrawerProps as MuDrawerProps } from "@mui/material/Drawer";

import DescriptionIcon from "@mui/icons-material/DescriptionOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import IntegrationInstructionsOutlinedIcon from "@mui/icons-material/IntegrationInstructionsOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import SidebarList from "../Sidebar/SidebarList";

import logo from "./../../assets/icons/WeberloLogo.svg";

const LIST_ITEM = [
  {
    title: "Report",
    icon: <DescriptionIcon />,
    isSelected: true,
    subItems: [
      {
        title: "Overview",
        isSelected: true,
      },
      {
        title: "Traffic",
      },
      {
        title: "Lead Generation",
      },
      {
        title: "Sales",
      },
    ],
  },
  {
    title: "Activity",
    icon: <InsightsOutlinedIcon />,
  },
  {
    title: "Setup",
    icon: <TuneOutlinedIcon />,
  },
  {
    title: "Tags",
    icon: <SellOutlinedIcon />,
  },
  {
    title: "Developer",
    icon: <IntegrationInstructionsOutlinedIcon />,
  },
  {
    title: "Settings",
    icon: <SettingsOutlinedIcon />,
  },
];

const DRAWER_WIDTH = 278;
export type ChipProps = MuDrawerProps & {};

const Drawer = ({ ...others }: ChipProps) => {
  return (
    <MuDrawer
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: DRAWER_WIDTH,
          boxSizing: "border-box",
          px: "24px",
          pt: "33px",
          gap: "56px",
        },
      }}
      variant="permanent"
      anchor="left"
      {...others}>
      <img
        style={{ width: "171.108px", height: "31px", flexShrink: 0 }}
        src={logo}
        alt="WeberloLogo"
      />
      <SidebarList headerTitle="DASHBOARD" onClickRoute={() => {}} listItems={LIST_ITEM} />
    </MuDrawer>
  );
};

export default Drawer;
